import { event, pixel_event, pixel_purchase_event, metric, dimension, event_with_callback, init, impression, ecommerce } from "./tracking.service";
// import Globals from "./globals.service";
import Settings from "./settings.service";
import Storage from "./storage.service";

var Events = {};

Events.invoke = (function_name) => {
	if (Events[function_name]) {
		Events[function_name]();
	}
};

Events.getCategoryByArea = () => {
	let sheet_area = Events.getArea();
	// log("sheet_area", sheet_area);

	if (
		sheet_area === "number/transfer" ||
		sheet_area === "number/transfer-terms"
	) {
		sheet_area = "Transfer Number";
	}

	if (sheet_area === "plan-selection") {
		sheet_area = "Plan";
	}

	if (sheet_area === "payment") {
		sheet_area = "Review";
	}

	if (sheet_area === "login") {
		sheet_area = "Account";
	}

	// log("final = ", "Checkout " + sheet_area.replace("_", " "));

	return "Checkout " + sheet_area.replace("_", " ");
};

Events.getArea = () => {
	let route = ""; // Flow.getCurrentRoute() || "";
	return route.substring(1).replace("/", "_");
};

Events.getPrice = (plan = null) => {
	// "<Price of the plan>"
	let amount = 0;
	if (!plan) {
		plan = Storage.get("saved_plan");
	}

	if (plan) {
		amount = plan.PackagePrice.NetPrice;
	}

	return amount;
};

Events.getPlanforTracking = (plan = null) => {
	let result = [];
	if (!plan) {
		plan = Storage.get("saved_plan");
	}
	if (plan) {
		for (let type of Settings.types_new_order) {
			let id = plan["vmo_subplans_ids_by_type"][type];
			if (id) {
				let val = plan["vmo_subplans"][id]["vmo_ValueFormatted"];
				result.push(val);
			}
		}
	}

	return result.join("|");
};

Events.getPlanTypeforTracking = (product = null) => {
	return "CUS";
};

Events.getNumberTypeforTracking = (number) => {
	return "Random";
};

Events.initTracking = () => {
	init();
};

Events.clicks_on_summary_edit_plan = (copy) => {
	// log("Events.clicks_on_summary_edit_plan()", copy);

	let event_name = "Clicks on edit plan icon";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plan Edit";
	let eventLabel = Events.getPlanforTracking();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_summary_edit_number = (copy, number) => {
	// log("Events.clicks_on_summary_edit_number()", copy, number);

	let event_name = "Clicks on edit number icon";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Edit";
	let eventLabel = Events.getNumberTypeforTracking(number);
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_fb_login = () => {
	// log("Events.clicks_on_fb_login()");
	let event_name = "Clicks on Facebook button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Registration";
	let eventLabel = "Facebook button clicked";
	// let eventValue = "";
	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_summary_confirm_product_change = (
	new_prod,
	old_prod,
	copy
) => {
	// log("Events.clicks_on_summary_confirm_product_change()", new_prod, old_prod, copy );
	let event_name = "Clicks on summary confirm product change";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Commitment Selection";
	let eventLabel = new_prod ? new_prod.CommitmentDuration : "";
	// let eventValue = "";
	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_summary_product_tab = (new_prod, old_prod, copy) => {
	// log("Events.clicks_on_summary_product_tab()", new_prod, old_prod, copy );

	let event_name = "Clicks on summary commitment tab";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Commitment Selection";
	let eventLabel = new_prod ? new_prod.CommitmentDuration : "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_summary_cancel_product_change = (new_prod, old_prod, copy) => {
	// log("Events.clicks_on_summary_confirm_product_change()", new_prod, old_prod, copy );
	let event_name = "Clicks on summary cancel product change";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Commitment Selection";
	let eventLabel = new_prod ? new_prod.CommitmentDuration : "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_promo_code_field = () => {
	// log("Events.clicks_on_promo_code_field()");

	let event_name = "Clicks on promo code field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promo code";
	// let eventLabel = ""
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_emirates_id_field = () => {
	// log("Events.clicks_on_emirates_id_field()");
	// let event_name = "Clicks on emirates id field";
	// let eventCategory = Events.getCategoryByArea();
	// let eventAction = "Promo code";
	// let eventLabel = ""
	// let eventValue = "";
	//event(event_name, eventCategory, eventAction);
};

Events.clicks_on_apply_promo_x = (promo_code) => {
	// log("Events.clicks_on_apply_promo_x()");

	let event_name = "Clicks on applied promo code clear (x)";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promo code";
	// let eventLabel = ""
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_promo_code_clear = () => {
	// log("Events.clicks_on_promo_code_clear()");

	let event_name = "Clicks on promo code field clear (x)";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promo code";
	// let eventLabel = ""
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_cancel_promo_cancellation = (promo_code, copy) => {
	// log("Events.clicks_on_cancel_promo_cancellation()", promo_code, copy);

	let event_name = "Clicks on cancel in promo code cancellation popup";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promo code";
	let eventLabel = promo_code;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_confirm_cancel_promo = (promo_code, copy) => {
	// log("Events.clicks_on_confirm_cancel_promo()", promo_code, copy);

	let event_name = "Clicks on confirm promo code cancellation";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promo code";
	let eventLabel = "Promo code cancelled";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_apply_promo_code = (promo_code, copy) => {
	// log("Events.clicks_on_apply_promo_code()", promo_code, copy);

	let event_name = "Clicks on apply promo code";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promo code";
	let eventLabel = promo_code;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_anghami_agree_checkbox = (val, copy) => {
	// log("Events.clicks_on_anghami_agree_checkbox()", val, copy);

	let event_name = "Clicks on Anghami agree checkbox";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Promotions";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_number_shuffle = (copy) => {
	// log("Events.clicks_on_number_shuffle()", copy);

	let event_name = "Clicks on shuffle link";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Shuffle";
	// let eventLabel = ""
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_book_shuffled_number = (copy) => {
	// log("Events.clicks_on_book_shuffled_number()", copy);

	let event_name = "Clicks on the CTA to continue with the random number";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_play_store_app_link = () => {
	// log("Events.clicks_on_play_store_app_link()", copy);

	let event_name = "Clicks on the Play Store button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Play Store CTA Clicked";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_thank_you_store_link = () => {
	// log("Events.clicks_on_play_store_app_link()", copy);

	let event_name = "Clicks on the 'find a Virgin Megastore' link";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Store Finder CTA";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_app_store_app_link = () => {
	// log("Events.clicks_on_app_store_app_link()", copy);

	let event_name = "Clicks on the App Store button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "App Store CTA Clicked";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_go_to_search = (copy) => {
	// log("Events.clicks_on_go_to_search()", copy);

	let event_name = "Clicks on the CTA to choose a specific number";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Specific Number CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_go_to_mnp = (copy) => {
	// log("Events.clicks_on_go_to_mnp()", copy);

	let event_name = "Clicks on the CTA to continue with the random number";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Transfer Number CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_clear_number_search_fragment = (copy, fragment) => {
	// log("Events.clicks_on_clear_number_search_fragment()", copy, fragment );

	let event_name = "Clicks into the 'number type in' area";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Entry";
	let eventLabel = "Number Deleted";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_number_search_submit = (copy, fragment) => {
	// log("Events.clicks_on_number_search_submit()", copy, fragment);

	let event_name = "Clicks on the number search CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Search CTA";
	let eventLabel = fragment;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_search_results_response = (results = []) => {
	// log("Events.when_search_results_response()", results);

	let event_name = "When search results are produced";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Search Result";
	let eventLabel = results.length ? "Results" : "No Results";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_number_search_field = () => {
	// log("Events.clicks_on_number_search_field()");

	let event_name = "Clicks into the 'number type in' area";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Entry";
	let eventLabel = Events.getPlanforTracking();

	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_number_search_load_more = (copy) => {
	// log("Events.clicks_on_number_search_load_more()", copy);

	let event_name = "Clicks on 'Show more numbers' link";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Search Result";
	let eventLabel = "Show More Numbers";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_account_email_field = () => {
	// log("Events.clicks_on_account_email_field()");

	let event_name = "Clicks into the 'Email' field";
	let eventCategory = Events.getCategoryByArea;
	let eventAction = "Email Entry";
	let eventLabel = Events.getPlanforTracking();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_account_password_field = () => {
	// log("Events.clicks_on_account_password_field()");

	let event_name = "Clicks into the 'Password' field";
	let eventCategory = Events.getCategoryByArea;
	let eventAction = "Password Entry";
	let eventLabel = Events.getPlanforTracking();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_google_login_succeeds = () => {
	// log("Events.when_google_login_succeeds()");
	let event_name = "Clicks on Google button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Registration";
	let eventLabel = "Facebook Google clicked";
	// let eventValue = "";
	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_google_login_fails = () => {
	// log("Events.when_google_login_fails()");
	let event_name = "Clicks on Google button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Registration";
	let eventLabel = "Facebook Google clicked";
	// let eventValue = "";
	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_account_password_eye = () => {
	// log("Events.clicks_on_account_password_eye()");

	let event_name = "Clicks on password eye toggle";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Password Entry";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_confirm_email_popup_yes = () => {
	// log("Events.clicks_on_confirm_email_popup_yes()");
	let event_name = "Click on CTA - YES";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Registration";
	let eventLabel = "Your email - yes";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_confirm_email_popup_no = () => {
	// log("Events.clicks_on_confirm_email_popup_no()");
	let event_name = "Click on CTA - NO";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Registration";
	let eventLabel = "Your email - no";
	// let eventValue = "";
	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_clear_email_field = () => {
	// log("Events.clicks_on_clear_email_field()");

	let event_name = "Clicks on the delete cross in the email entry field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Email Entry";
	let eventLabel = "Email Deleted";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_clear_password_field = () => {
	// log("Events.clicks_on_clear_password_field()");

	let event_name = "Clicks on the delete cross in the password entry field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Password Entry";
	let eventLabel = "Password Deleted";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_submit_account_form = (copy) => {
	// log("Events.clicks_on_submit_account_form()", copy);

	let event_name = "Clicks on the continue CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	// let eventLabel = "Password Deleted";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.when_account_form_shows_validation_message = (copy) => {
	// log("Events.when_account_form_shows_validation_message()", copy);

	let event_name = "When a field validation message appears on Account page";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Field Validation Error";
	let eventLabel = "Email"; // <Field that errored: Email / Password>
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_resident_form_yes = (copy) => {
	// log("Events.clicks_on_resident_form_yes()", copy);

	let event_name = "Clicks on the primary CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_confirm_stored_number = (copy) => {
	// log("Events.clicks_on_confirm_stored_number()", copy);

	let event_name = "Clicks on the primary stored number CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Stored number";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cancel_stored_number = (copy) => {
	// log("Events.clicks_on_cancel_stored_number()", copy);

	let event_name = "Clicks on the secondary stored number CTA hyperlink";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Stored number";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_resident_form_no = (copy) => {
	// log("Events.clicks_on_resident_form_no()", copy);

	let event_name = "Clicks on the secondary CTA hyperlink";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Not Resident CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.non_resident_arrived_at_payment = () => {
	// log("Events.non_resident_arrived_at_payment()");
	let event_name = "Non-resident arrived at payment";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Non-resident arrived at payment";
	let eventLabel = "Non-resident";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_non_resident_form_cta = (copy) => {
	// log("Events.clicks_on_non_resident_form_cta()", copy);

	let event_name = "Clicks on the primary CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_non_resident_form_store_link = (copy) => {
	// log("Events.clicks_on_non_resident_form_store_link()", copy);

	let event_name = "Clicks on the secondary CTA hyperlink";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Store Finder CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_delivery_map_trigger = () => {
	// log("Events.clicks_on_delivery_map_trigger()");

	let event_name = "Clicks on the map icon";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Map Icon";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_address_clear = () => {
	// log("Events.clicks_on_delivery_form_address_clear()");

	let event_name = "Clicks on the Address field clear icon";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Field Cleared";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_map_address_field = () => {
	// log("Events.clicks_on_delivery_form_map_address_field()");

	let event_name = "Clicks into the map Address field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Field Interaction";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_address_field = () => {
	// log("Events.clicks_on_delivery_form_address_field()");

	let event_name = "Clicks into the Address field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Field Interaction";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_address_field_line_2 = () => {
	// log("Events.clicks_on_delivery_form_address_field_line_2()");

	let event_name = "Clicks into the 2nd field (Apartment)";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address 2 Field Interaction";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_instructions_field = () => {
	// log("Events.clicks_on_delivery_form_instructions_field()");

	let event_name = "Clicks into the Instructions field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Instructions Field Interaction";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_number_field = () => {
	// log("Events.clicks_on_delivery_form_number_field()");

	let event_name = "Clicks into the Number field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Field Interaction";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_submit = (copy) => {
	// log("Events.clicks_on_delivery_form_submit()", copy);

	let event_name = "Clicks on the primary CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = Events.getPlanforTracking();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_delivery_form_prefer_pickup = (copy) => {
	// log("Events.clicks_on_delivery_form_prefer_pickup()", copy);

	let event_name = "Clicks on the pickup in store hyperlink";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Collect in Store CTA";
	let eventLabel = Events.getPlanforTracking();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_delivery_map_search_field = () => {
	// log("Events.clicks_on_delivery_map_search_field()");

	let event_name = "Clicks into the search field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Map Field Interaction";
	// let eventLabel = Events.getNumberTypeforTracking(number);
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_map_set_address = (copy) => {
	// log("Events.clicks_on_delivery_map_set_address()", copy);

	let event_name = "Clicks on the 'Deliver Here' CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Map Deliver Here CTA";
	// let eventLabel = Events.getNumberTypeforTracking(number);
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_form_predictions_open_map = (copy, first_result) => {
	// i dont see my location
	// log("Events.clicks_on_delivery_form_predictions_open_map()", copy);
	let event_name =
		"User clicks on 'I don't see my address here' from the result dropdown list";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Field Results";
	let eventLabel = first_result;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_delivery_form_autocomplete_prediction = (copy) => {
	// log("Events.clicks_on_delivery_form_autocomplete_prediction()", copy);

	let event_name =
		"User clicks on an Address result from the result dropdown list";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Field Results";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_mnp_form_operator = (copy) => {
	// log("Events.clicks_on_mnp_form_operator()", copy);

	let event_name = "Clicks on an operator option";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Operator Field Interaction";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_mnp_form_number_field = () => {
	// log("Events.clicks_on_mnp_form_number_field()");

	let event_name = "Clicks into the Number field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Field Interaction";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_mnp_form_authorise_field = (copy, val) => {
	// log("Events.clicks_on_mnp_form_authorise_field()");

	let event_name = "Clicks on the radio button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Authorised Field Interaction";
	let eventLabel = Events.getPlanforTracking();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_mnp_form_submit = (copy) => {
	// log("Events.clicks_on_mnp_form_operator()", copy);

	let event_name = "Clicks on the primary CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_toggle_faq_question = (copy, expanded) => {
	// log("Events.clicks_on_toggle_faq_question()", copy, expanded);

	if (expanded) {
		let event_name = "Clicks to expand an FAQ";
		let eventCategory = Events.getCategoryByArea();
		let eventAction = "FAQ Question Opened";
		let eventLabel = copy;
		// let eventValue = "";

		event(event_name, eventCategory, eventAction, eventLabel);
	}
};

Events.clicks_on_toggle_faq_helpful = (copy, helpful) => {
	// log("Events.clicks_on_toggle_faq_helpful()", copy, helpful);

	let event_name = "Clicks on an FAQ rating";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "FAQ Question Rated";
	let eventLabel = copy + " | " + helpful ? "Good" : "Bad";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_mnp_terms_edit_number = () => {
	// log("Events.clicks_on_mnp_terms_edit_number()");

	let event_name = "When the user clicks on the red number icon";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Edit";
	// let eventLabel = ""
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_mnp_terms_agree_checkbox = (copy) => {
	// log("Events.clicks_on_mnp_terms_agree_checkbox()", copy);

	let event_name = "Clicks on the first agreement radio button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Agreed Radio Button";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_mnp_terms_cta = (copy) => {
	// log("Events.clicks_on_mnp_terms_cta()", copy);

	let event_name = "Clicks on the primary CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_form_card_field = () => {
	// log("Events.clicks_on_cc_card_form_card_field()");

	let event_name = "Clicks into the 'Card Number' field";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Card Number Field Interaction";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_form_cvv_field = () => {
	// log("Events.clicks_on_cc_card_form_cvv_field()");

	let event_name = "Clicks into the 'CVV' field";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Cardholder CVV Field Interaction";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_form_cardholder_field = () => {
	// log("Events.clicks_on_cc_card_form_cardholder_field()");

	let event_name = "Clicks into the 'Cardholder name' field";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Cardholder Name Field Interaction";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_form_date_field = () => {
	// log("Events.clicks_on_cc_card_form_date_field()");

	let event_name = "Clicks into the 'Expiry Date' field";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Cardholder Expiry Field Interaction";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_form_save_card_field = (copy, val) => {
	// log("Events.clicks_on_cc_card_form_save_card_field()", copy, val);

	let event_name = "Clicks into the 'Save card' field";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Cardholder Save Card Field Interaction";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_terms_field = (copy, val) => {
	// log("Events.clicks_on_cc_card_terms_field()", copy, val);

	let event_name = "Clicks on the 'terms and conditions' hyperlink";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Terms and Conditions";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_cc_card_form_submit = (copy, amount) => {
	// log("Events.clicks_on_cc_card_form_submit()", copy, amount);

	let event_name = "Clicks into the pay CTA";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Pay Online CTA";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_payment_card_option = (copy) => {
	// log("Events.clicks_on_payment_card_option()", copy);

	let event_name = "Clicks on the 'Pay Now' CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Pay Online CTA";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_payment_on_delivery_option = (copy) => {
	// log("Events.clicks_on_payment_on_delivery_option()", copy);

	let event_name = "Clicks on the 'Pay on Delivery' CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Pay on Delivery CTA";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plans_country_rates = (copy) => {
	// log("Events.clicks_on_plans_country_rates()", copy);

	let event_name = "Clicks on Plans country rates link";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plans";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plans_page_cta = (copy) => {
	// log("Events.clicks_on_plans_page_cta()", copy);
	let event_name = "Clicks on Plans Main CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plan Change";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plan_circle_control = (direction, type) => {
	// log("Events.clicks_on_plan_circle_control()", direction, type);

	let type_text = type;

	if (type === "VOICE-LCL") {
		type_text = "UAE Mins";
	}

	if (type === "VOICE-INT") {
		type_text = "International";
	}

	if (type === "DATA") {
		type_text = "Data";
	}

	let event_name = "Clicks on Plan control";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plan Change";
	let eventLabel = type_text + " " + direction;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_vip_product = (copy, plan) => {
	// log("Events.clicks_on_vip_product()", copy, plan);
	let event_name = "Clicks on a VIP plan CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "VIP plans";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_payg_plan_cta = (copy) => {
	// log("Events.clicks_on_payg_plan_cta()", copy);

	let event_name = "Clicks on PAYG plan CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "PAYG plans";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plans_vat_toggle = (copy, newval) => {
	// log("Events.clicks_on_plans_vat_toggle()", copy, newval);

	let event_name = "Clicks on Plans VAT switch";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plans";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plans_tab = (which, copy) => {
	// log("Events.clicks_on_plans_tab()", which, copy);

	let event_name = "Clicks on a plan tab";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plans tabs";
	let eventLabel = which;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_boosters_daily_limit = (copy) => {
	// log("Events.clicks_on_boosters_daily_limit()", copy);

	let event_name = "Clicks on PAYG boosters daily limit";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "PAYG plans";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_payg_recharge_option = (val, copy) => {
	// log("Events.clicks_on_payg_recharge_option()", val, copy);

	let event_name = "Clicks on PAYG boosters recharge";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "PAYG plans";
	let eventLabel = val;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_boosters_no_daily_limit = (copy) => {
	// log("Events.clicks_on_boosters_no_daily_limit()", copy);

	let event_name = "Clicks on PAYG boosters no daily limit";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "PAYG plans";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_boosters_tab = (which, copy) => {
	// log("Events.clicks_on_boosters_tab()", which, copy);

	let event_name = "Clicks on PAYG boosters tab";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "PAYG plans";
	let eventLabel = which;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.toggle_plan_perks_visibility = (copy, where, newval) => {
	// log("Events.clicks_on_plans_tab()", copy, where, newval);
	let event_name = "Clicks on expand plan perks";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plans";
	let eventLabel = where;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plan_page_commitment = (product) => {
	// log("Events.clicks_on_plan_page_commitment()", product);

	let event_name = "Clicks on a plan commitment";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plans";
	let eventLabel = product ? product.CommitmentDuration : "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_value_plan_cta = (copy, price) => {
	// log("Events.clicks_on_value_plan_cta()", copy, price);

	let event_name = "Clicks on Value Plan CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Value plans";
	let eventLabel = price;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.http_error = (code, type, value) => {
	// log("Events.http_error()", code, type);
	metric("Error_messages_tech", 1);
	dimension("Error_messages_tech", code);

	let event_name = "error";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "http";
	let eventLabel = code;
	let eventValue = value;

	event(event_name, eventCategory, eventAction, eventLabel, eventValue);
};

Events.clicks_on_number_search_vanity_menu_item = (vanity) => {
	// log("Events.clicks_on_number_search_vanity_menu_item()", vanity);

	let event_name = "Clicks on a search filter";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Filter numbers";
	let eventLabel = vanity ? vanity.value : "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.toggle_number_search_vanity_menu = () => {
	// log("Events.toggle_number_search_vanity_menu()");

	let event_name = "Clicks on search filters menu";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Filter numbers";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_cc_card_newsletter_field = (copy, val) => {
	// log("Events.clicks_on_cc_card_newsletter_field()", copy, val);

	let event_name = "Clicks into the 'Newsletter' field";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Newsletter Field Interaction";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_vip_number_confirmation = (copy, vanity) => {
	// log("Events.clicks_on_vip_number_confirmation()", copy);

	let event_name = "Clicks on a VIP number confirmation CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "VIP plans";
	let eventLabel = vanity;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_vip_number_cancel = (copy, vanity) => {
	// log("Events.clicks_on_vip_number_confirmation()", copy);

	let event_name = "Clicks on a VIP number secondary CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "VIP plans";
	let eventLabel = vanity;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_faq_feedback_submit = (feedback) => {
	// log("Events.clicks_on_faq_feedback_submit()", feedback);
	let event_name = "Clicks on an FAQ feedback CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "FAQ Question Feedback";
	// let eventLabel = "";
	// let eventValue = "";

	event(event_name, eventCategory, eventAction);
};

Events.clicks_on_delivery_map_find_store = (copy) => {
	// log("Events.clicks_on_delivery_map_find_store()", copy);

	let event_name = "Clicks on the 'Find Store' CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Address Map Find Store CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_user_uses_email_form_to_register = () => {
	// log("Events.when_user_uses_email_form_to_register()");
	dimension("Registration_type_flow", "Email");
	metric("Email subscription (Yes-button)", 1);
};

Events.when_user_logs_out = () => {
	// log("Events.when_user_logs_out()");
	dimension("customer_status", "not logged in");
	dimension("uid", 0);
	dimension("Unique_User_ID_session", "");
	dimension("Unique_User_ID_user", "");
	dimension("registration_type", "");
	dimension("Promotion_type", "");
	dimension("Plan selected (Customer)", "");
	dimension("Number selected (Customer)", "");
	dimension("Promotion_type", "");
	dimension("Promotion_type", "");
};

Events.when_user_session_is_found = () => {
	// log("Events.when_user_session_is_found()");
	dimension("customer_status", "logged in");
};

Events.when_user_registers_using_type = (type) => {
	// log("Events.when_user_registers_using_type()", type);
	dimension("Registration_type_flow", type);
	dimension("Registration_type_customer", type);
};

Events.when_user_registration_type_is_found = (type) => {
	// log("Events.when_user_registration_type_is_found()", type);
	dimension("registration_type", type);
};

Events.when_user_id_is_found = (uid) => {
	// log("Events.when_user_id_is_found()", uid);
	dimension("uid", uid);
};

Events.when_user_account_id_is_set = (account_id) => {
	// log("Events.when_user_account_id_is_set()", account_id);
	dimension("account_id", account_id);
};

Events.when_plan_is_selected = () => {
	// log("Events.when_plan_is_selected()");
	let plan = Storage.get("saved_plan");

	let product = Storage.get("selectedProduct");

	let coupon = "";

	let promotion = null;
	if (plan && plan.Promotions) {
		for (let promo of plan.Promotions) {
			if (promo && promo["IsUserPromo"]) {
				promotion = promo;
				break;
			}
		}
	}

	let sub_plan_values = Events.getPlanforTracking();

	if (promotion) {
		coupon = promotion.Category;
	}

	let type = Events.getPlanTypeforTracking();

	impression({
		price: Events.getPrice(),
		name: product["Name"],
		id: sub_plan_values,
		category: "SIM",
		variant: type,
		coupon: coupon ? coupon : "",
	});

	let formatted = "";

	if (type === "PAYG") {
		let recharge_amount = 0;

		let extraCharges = plan.PackagePrice.ExtraCharges;
		for (let charge of extraCharges) {
			if (charge["Name"] === "RechargeAmount") {
				recharge_amount = charge["Amount"];
				break;
			}
		}

		formatted = type + " " + recharge_amount;
	} else {
		formatted =
			type + " " + product["CommitmentDuration"] + "|" + sub_plan_values;
	}

	dimension("Plan selected (Selected)", formatted);
};

Events.when_number_is_selected = (numberobj) => {
	// log("Events.when_number_is_selected()", numberobj);
	dimension(
		"Number selected (Selected)",
		Events.getNumberTypeforTracking(numberobj)
	);
};

Events.clicks_on_number_search_result = (number, index_in_list) => {
	// log("Events.clicks_on_number_search_result()", number, index_in_list);

	let event_name = "Clicks on a number search result";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Number Search Result";
	let eventLabel = index_in_list;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};



Events.clicks_on_plans_int_mins_continue = (copy) => {
	// log("Events.clicks_on_plans_int_mins_continue()");

	let event_name = "Clicks on a international minutes continue CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Continue CTA";
	let eventLabel = copy;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.clicks_on_plan_circle_info_icon = (type) => {
	// log("Events.clicks_on_plan_circle_info_icon()", type);

	let event_name = "Clicks on Plan circle info icon";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Plans";
	let eventLabel = type;
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_user_cancels_CC_form = (copy) => {
	// log("Events.when_user_cancels_CC_form()");

	let event_name = "Clicks on the pay now cancel button";
	let eventCategory = "Checkout Pay Online";
	let eventAction = "Pay Online";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_user_cancels_POD = (copy) => {
	// log("Events.when_user_submits_POD()");

	let event_name = "Clicks on the pay on delivery cancel button";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Pay on delivery";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_user_submits_POD = (copy) => {
	// log("Events.when_user_submits_POD()");

	let event_name = "Clicks on the pay on delivery confirm CTA";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Pay on delivery CTA";
	let eventLabel = Events.getPrice();
	// let eventValue = "";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.when_POD_fails = (type, code) => {
	// GTMService.action_on_POD();

	let title = "";
	// if (Globals["messages"][type]) {
	// 	title = Globals["messages"][type]["title"];
	// }

	let coder = code !== true ? code : "";

	metric("Error_messages_tech", 1);
	dimension("Error_messages_tech", coder);

	event(
		"POD_failed",
		"Payment",
		"POD failed",
		title ? title + (coder ? "/" + coder : "") : coder
	);
};

Events.when_payment_fails = (type, code, where = "") => {
	// log("Events.when_payment_fails()", type, code);

	let title = "";
	// if (Globals["messages"][type]) {
	// 	title = Globals["messages"][type]["title"];
	// }

	let coder = code !== true ? code : "";

	metric("Error_messages_tech", 1);
	dimension("Error_messages_tech", coder);

	event(
		"Payment_failed",
		"Checkout Pay Online",
		"Payment failed",
		title
			? title + (coder ? "/" + coder : "") + " " + where
			: coder + " " + where
	);
};

// @TODO

let when_pod_or_card_succeeds = () => {
	let product = Storage.get("selectedProduct");
	let commit = product ? product.CommitmentDuration : "";

	let sub_plan_value = Events.getPlanforTracking();

	let type = Events.getPlanTypeforTracking();

	let transactionId = Storage.get("order_id");

	let transactionTotal = Events.getPrice();

	let SKU = type + " " + commit + "|" + sub_plan_value;

	let name = SKU;

	ecommerce(transactionId, transactionTotal, SKU, name);
};

Events.when_POD_succeeds = () => {
	// log("Events.when_POD_succeeds()");
	metric("Payment on delivery", 1);
	when_pod_or_card_succeeds();
};

Events.when_payment_succeeds = () => {
	// log("Events.when_payment_succeeds()");
	event(
		"Payment_successful",
		"Checkout Pay Online",
		"Payment successful",
		"Success"
	);

	metric("Credit card payment", 1);
	when_pod_or_card_succeeds();
};

Events.resident_paid_online_arrived_at_thank_you = () => {
	// log("Events.resident_paid_online_arrived_at_thank_you()");
	let event_name = "Resident (online-flow) arrived at payment";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Resident (online-flow) arrived at payment";
	let eventLabel = "Resident (online-flow)";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.non_resident_paid_online_arrived_at_thank_you = () => {
	// log("Events.non_resident_paid_online_arrived_at_thank_you()");
	let event_name = "Non-resident (online-flow) arrived at thank you";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Non-resident (online-flow) arrived at thank you";
	let eventLabel = "Non-resident (online-flow)";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.non_resident_collect_store_arrived_at_thank_you = () => {
	// log("Events.non_resident_collect_store_arrived_at_thank_you()");
	let event_name = "Non-resident (collect in store) arrived at thank you";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Non-resident (collect in store) arrived at thank you";
	let eventLabel = "Non-resident (collect in store)";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.resident_collect_store_arrived_at_thank_you = () => {
	// log("Events.resident_collect_store_arrived_at_thank_you()");
	let event_name = "Resident (collect in store) arrived at thank you";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Resident (collect in store) arrived at thank you";
	let eventLabel = "Resident (collect in store)";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.non_resident_arrived_at_thank_you = () => {
	// log("Events.non_resident_arrived_at_thank_you()");
	let event_name = "Non-resident arrived at thank you";
	let eventCategory = Events.getCategoryByArea();
	let eventAction = "Non-resident arrived at thank you";
	let eventLabel = "Non-resident";

	event(event_name, eventCategory, eventAction, eventLabel);
};

Events.redirectd_to_thank_you = (callback) => {
	let event_name = "Redirects to thank you page";
	let eventCategory = "Checkout Payment";
	let eventAction = "Redirect To Thank You Page";
	let eventLabel = "Payment completed";
	if (typeof callback === "function") {
		event_with_callback(
			event_name,
			eventCategory,
			eventAction,
			eventLabel,
			callback
		);
	} else {
		event(event_name, eventCategory, eventAction, eventLabel);
	}
};

Events.reached_to_thank_you_page = () => {
	let event_name = "Reached thank you page";
	let eventCategory = "Checkout Confirmation";
	let eventAction = "Confirmation. Reached";
	event(event_name, eventCategory, eventAction);
};

//pixels events
Events.clicks_on_pixel_plan_selected = () => {
	let event_name = "pixel_plan_selected";
	let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
	let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
	let eventValue = Storage.get("pixel_plan_price");
	pixel_event(event_name, plan_selection_1, plan_selection_2, eventValue);
};

Events.clicks_on_pixel_account_created = () => {
	let event_name = "pixel_account_created";
	let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
	let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
	let eventValue = Storage.get("pixel_plan_price")
		? Storage.get("pixel_plan_price")
		: Events.getPrice();
	pixel_event(event_name, plan_selection_1, plan_selection_2, eventValue);
};

Events.pixel_payment_page_viewed = () => {
	let event_name = "pixel_payment_viewed";
	let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
	let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
	let eventValue = Storage.get("pixel_plan_price")
		? Storage.get("pixel_plan_price")
		: Events.getPrice();
	pixel_event(event_name, plan_selection_1, plan_selection_2, eventValue);
};

Events.pixel_purchase = () => {
	let event_name = "pixel_purchase";
	let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
	let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
	let eventValue = Storage.get("pixel_plan_price")
		? Storage.get("pixel_plan_price")
		: Events.getPrice();
	let transaction_id = Storage.get("order_id")
		? Storage.get("order_id")
		: Storage.get("selected_store_pickup") ? "PIN" : "POD";
	pixel_purchase_event(
		event_name,
		plan_selection_1,
		plan_selection_2,
		eventValue,
		transaction_id
	);
};

//Money Back Guarentee Modal events
Events.money_back_guarentee_conditions_apply_clicked = (hyperlink_label) => {
	let event_name = hyperlink_label;
	let eventCategory = "Refund";
	let eventAction = "Hyperlink clicked";
	event(event_name, eventCategory, eventAction);
};

Events.money_back_guarentee_refund_faq_clicked = (hyperlink_label) => {
	let event_name = hyperlink_label;
	let eventCategory = "Refund";
	let eventAction = "Overlay hyperlink";
	event(event_name, eventCategory, eventAction);
};

Events.money_back_guarentee_modal_overlay_closed = (close_modal_label) => {
	let event_name = close_modal_label;
	let eventCategory = "Refund";
	let eventAction = "Overlay closed";
	event(event_name, eventCategory, eventAction);
};

//Above 18 modal events
Events.under_18_please_read_link_clicked = (hyperlink_label) => {
	let event_name = hyperlink_label;
	let eventCategory = "Account Creation";
	let eventAction = "Under 18 clicked";
	event(event_name, eventCategory, eventAction);
};

Events.under_18_modal_family_Plan_link_clicked = () => {
	let eventCategory = "Account Creation";
	let eventAction = "Family Plan link clicked";
	event(eventCategory, eventAction);
};

Events.under_18_modal_overlay_CTA_clicked = (close_modal_label) => {
	let event_name = close_modal_label;
	let eventCategory = "Account Creation";
	let eventAction = "Overlay CTA clicked";
	event(event_name, eventCategory, eventAction);
};

Events.user_interacts_with_accessibility_options = (which_button) => {
	event(
		"User interacts with accessibility options",
		"Accessibility",
		"Header accessibility option clicked",
		which_button
	);
};

Events.registration_apps_link_clicked = () => {};

Events.locationSelectedConfirmation = (SelectedLocation, speedType ) =>{

	let res = {
		event: 'locationSelect',
		details: {
    locationValue: SelectedLocation,
				coverageType : speedType.planSpeed,
   },
	}
	event("locationSelect" , "Coverage check" , 
	null , 
	null , 
	res)
}

Events.plansSelectionConfirmation = (plansData) => {
	let res = {
		event :'planSelect',
		details: {
      planName: plansData.name,
      planType: 'UnlimitedData',
      value: plansData.price,
      planDuration: 'monthly'
  },
	}
	event('planSelect', "Plan Selection", null , null ,res, );
}
Events.accountActivated = (userData) => {
	let res = {
			event : 'accountLogin', 
			details: {
      userPlan: userData.selectedPlan,
      userID: userData.accountId,
      value: userData.planPrice
 	},
	}
	event("accountLogin", "Account Creation", null, null, res)
}
Events.deliveryAddressConfirmation = (addressData) => {

		let res = {
			event : 'deliveryAddress', 
			details: {
      deliveryAddresstype : addressData.deliveryAddresstype,
      value: addressData.price,
 	},
	}
	event("deliveryAddress", "delivery address data", null, null, res)
}

Events.purchaseConfirmation = (summaryData) => {
	  let planName = Storage.get('planName');
   let planPrice = Storage.get('PlanPrice');
   let planSpeed = Storage.get('planSpeed');
let res = {
	event: 'purchase',
  details: {
      planName: planName,
      planType: 'UnlimitedData',
      value: planPrice,
      planDuration: 'monthly',
      planSpeed: planSpeed,  
      couponCode: ' '
  }
}
	event("purchase", "Summary data boxes", null, null, res)
}
Events.redirectFromTheHomeInternet = (redirectData) =>{
	let res = {
	event: 'viewPromotion',
  ecommerce: {
    		promotionName: redirectData.source,
      promotionUrl: redirectData.url
  }
	}
	event("viewPromotion", "Redirect form the home internet", null, null, res)
}
Events.when_account_is_created = () => {
	let event_name = "Form is successfully sent by the user";
	let eventCategory = "Form success";
	let eventAction = "Form successfully submitted";
	let eventLabel = "Home Internet";
	event(event_name, eventCategory, eventAction, eventLabel);
}

Events.clicks_on_installments_available_in_plan_page = () => {
	let event_name = "User clicks on ‘Installments available’ on the plan page";
	let eventCategory = "MBB Installments available";
	let eventAction = "hyperlink clicked";
	let eventLabel = "Installments available"
	event(event_name, eventCategory, eventAction, eventLabel);
  }
  
  Events.user_continues_with_installments_payment_selected = (selected_plan) => {
	let event_name = "User continues on the payment overlay with Installments option selected";
	let eventCategory = "MMB Installments chosen";
	let eventAction = "Payment method chosen";
	let eventLabel = selected_plan
	
	event(event_name, eventCategory, eventAction, eventLabel);
  }
  
  Events.user_chooses_to_scan_ID = () => {
	let event_name = "When the user chooses to scan ID";
	let eventCategory = "MBB Installments scan ID";
	let eventAction = "CTA clicked";
	let eventLabel = "Upload back side"
  
	event(event_name, eventCategory, eventAction, eventLabel);
  }
  
  Events.user_chooses_to_upload_ID = () => {
	let event_name = "When the user chooses to upload ID";
	let eventCategory = "MBB Installments upload ID";
	let eventAction = "CTA clicked";
	let eventLabel = "Continue"
  
	event(event_name, eventCategory, eventAction, eventLabel);
  }
  
  Events.user_chooses_to_reupload_ID = () => {
	let event_name = "When the user clicks to reupload ";
	let eventCategory = "MBB Installments reupload ID";
	let eventAction = "CTA clicked";
	let eventLabel = "Rescan ID"
  
	event(event_name, eventCategory, eventAction, eventLabel);
  }
  
  Events.user_goes_to_spotii_after_ID_upload = () => {
	let event_name = "When the user uploaded ID and clicks on the CTA to go to Spotii";
	let eventCategory = "MBB Installments Go To Spotii CTA";
	let eventAction = "CTA clicked";
	let eventLabel = "Continue"
  
	event(event_name, eventCategory, eventAction, eventLabel);
  }

Events.clicks_on_plan_upsell_primary_CTA = (btnCopy) => {
	let event_name = "clicks on plan upsell primary CTA";
	let eventCategory = "Plan upsell";
	let eventAction = "Primary CTA clicked";
	let eventValue =  "When the user is on the plan upsell page and clicks the primary CTA";
	let eventLabel = btnCopy;
	event(event_name, eventCategory, eventAction, eventLabel, eventValue);
}
Events.clicks_on_plan_upsell_secondary_CTA = (btnCopy) => {
	let event_name = "clicks on plan upsell secondary CTA"
	let eventCategory = "Plan upsell";
	let eventAction = "Secondary CTA clicked";
	let eventValue =  "When the user is on the plan upsell page and clicks the secondary CTA";
	let eventLabel = btnCopy;
	event(event_name, eventCategory, eventAction, eventLabel, eventValue);
}
Events.user_upgraded_plan = (prevDuration) => {
	let event_name = "user upgraded plan"
	let eventCategory = "Plan upsell";
	let eventAction = "Plan upgraded";
	let eventValue =  "When the user increased their plan to 12months on checkout after having a lower duration on the plan page";
	let eventLabel = "from duration one month";
	if (Storage.get("plan_upgraded") === true){
		event(event_name, eventCategory, eventAction, eventLabel, eventValue);
	}
}
Events.when_user_clicks_on_a_affiliate_VMS_hyperlink = (action, product) => {
	let event_name = "eventTracker";
  let eventCategory = "affiliate_wms";
		let eventAction = action;
		let eventLabel = product;
		event(event_name, eventCategory, eventAction, eventLabel);
}

Events.when_id_upload_fails_for_instalments = (failure_reason) => {
	let event_name = "cashew instalments";
	let eventCategory = "id upload failure for instalments";
	let eventAction = "id uploaded";
  
	event(event_name, eventCategory, eventAction, failure_reason);
  }

  Events.when_user_uploads_or_scans_id_succeffully_for_instalments = (upload_or_scan) => {
	let event_name = "cashew instalments";
	let eventCategory = `instalment backside id successful ${upload_or_scan}`;
	let eventAction = `${upload_or_scan}`;
  
	event(event_name, eventCategory, eventAction);
  }

  Events.when_user_chooses_upload_method_on_mobile = (upload_or_scan) => {
	let event_name = "eventTracker";
	let eventCategory = 'instalment upload method';
	let eventAction = `${upload_or_scan}`;

	event(event_name, eventCategory, eventAction);
  }
  
export default Events;
